export type TeamVisibilityOption = {
  value: string;
  label: string;
};

export function addWorkdayTeamTag(existing: string[], department: string | null | undefined): string[] {
  const name = department?.trim();
  if (!name || existing.includes(name)) return existing;
  return [...existing, name];
}

export function buildTeamVisibilityOptions(
  departments: string[],
  selectedTeamTags: string[],
  searchTerm: string
): TeamVisibilityOption[] {
  const normalizedSearch = searchTerm.trim().toLowerCase();
  return departments
    .filter((department) => !selectedTeamTags.includes(department))
    .filter((department) => !normalizedSearch || department.toLowerCase().includes(normalizedSearch))
    .map((department) => ({
      value: department,
      label: department
    }));
}
